<template>
  <div
    class="product-list"
    @click.stop
  >
    <HealthNav
      v-if="longParams.channelId === healthChannelId && union !== noHeadUnion"
    />
    <div
      v-if="
        catList.length > 0 &&
          !['3', healthChannelId].includes(longParams.channelId)
      "
    >
      <NavIndex
        v-if="longParams.channelId != 998"
        :catList="catList"
        :onChange="onCateNavChange"
      />
      <BookNavIndex
        v-if="longParams.channelId == 998"
        :catList="catList"
        :onChange="onBookNavChange"
      />
    </div>
    <div
      v-if="catList.length > 0 && longParams.channelId !== healthChannelId"
      class="bread"
    >
      <a
        :href="
          longParams.channelId === '3'
            ? '/shop/birthday'
            : longParams.channelId === '998' || longParams.channelId === '18'
              ? '/book'
              : '/shop/home'
        "
        target="_self"
      >{{
        longParams.channelId === "3"
          ? TLang('生日汇', 'my')
          : longParams.channelId === "998" || longParams.channelId === "18"
            ? TLang('图书', 'my')
            : TLang('优选生活', 'my')
      }}</a>
      <img
        src="@/assets/images/arrow.png"
        alt=""
        class="arrow"
      />
      <span>{{ TLang('商品列表','list') }}</span>
    </div>
    <div v-if="catList.length > 0">
      <SelectBar
        :hideBrand="longParams.channelId !== healthChannelId"
        :catList="catList"
        :brandList="brandList"
        :selectType="'list'"
        :onCateChange="onCateChange"
        :onBrandChange="
          (brandname) => {
            longParams = {
              ...longParams,
              pageNumber: 1,
              brandName: brandname,
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :chooseAll="chooseAll"
        :changeBirthdayFirstType="changeBirthdayFirstType"
      />
    </div>
    <!--健康商城没有开通不显示-->
    <div
      v-show="
        longParams.channelId === healthChannelId
          ? exts && exts.includes(5) && Number(healthgoodsFlag) === 0
            ? false
            : true
          : true
      "
      class="SearchBar-wrap"
    >
      <SearchBar
        :onSortFieldChange="
          (sortField) => {
            longParams = {
              ...longParams,
              sortField,
              sortType:'',
              pageNumber: 1
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :onSortTypeChange="
          (sortType) => {
            longParams = {
              ...longParams,
              sortField: 4,
              sortType,
              pageNumber: 1,
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :onPriceChange="
          (price) => {
            longParams = {
              ...longParams,
              ...price,
              pageNumber: 1,
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :onKeyWordChange="
          (wordsName) => {
            longParams = {
              ...longParams,
              wordsName,
              pageNumber: 1,
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :onStockChange="
          (containsNoStock) => {
            longParams = {
              ...longParams,
              containsNoStock,
              pageNumber: 1,
            };
            addPageNumbberQuery({
              pageNumber:'',
            })
            init();
          }
        "
        :total="total"
        :noStockGrayStatus="noStockGrayStatus"
      />
    </div>
    <FixedButton
      v-if="longParams.channelId == healthChannelId"
      hidenQrcode
      hidenToTop
    />
    <div class="goods-wrap">
      <ul>
        <li
          v-for="goods in goodsList"
          :key="goods.goodsId"
        >
          <Goods
            :goods="goods"
            :onClick="toDetailAndMemory"
            :onClickAdd="onClickAdd.bind(this, goods)"
            :purchaseType="goods.purchaseType"
          />
        </li>
      </ul>
      <Empty
        v-if="isEmpty"
        :hideCity="longParams.channelId !== healthChannelId"
        :topre="topre"
      />
    </div>
    <div
      v-if="goodsList.length && total > 20"
      class="Pagination"
    >
      <Pagination
        :current-page.sync="longParams.pageNumber * 1"
        :page-size="20"
        layout="prev, pager, next, total, jumper"
        :total="total"
        background
        @current-change="handleCurrentChange"
      ></Pagination>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <FixedButton :channelName="longParams.channelId === healthChannelId ? TLang('健康商城', 'my') : TLang('优选生活', 'my')" />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img
        :src="require('@/assets/images/successIcon.svg')"
        style="width: 55px;height: 36px;"
      />
      <div class="title">
        {{ TLang('加入购物车成功','my') }}
      </div>
      <div class="goods-name">
        {{ chooseOfAdd.goodsName }}
      </div>
      <div class="goods-sku-name">
        {{ TLang('规格','my') }}：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div>
      <div class="btns">
        <button
          :class="CookiesOne==='en-US' ?'close-btn close-btn-One':'close-btn' "
          @click="toDetail(chooseOfAdd)"
        >
          {{ TLang('查看商品详情','my') }}
        </button>
        <button
          class="buy-btn primary"
          @click="onClickGoBuy"
        >
          {{ TLang('去结算','my') }}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { fetchProductListById, fetchGoodsTags } from "@fetch";
import { getQueryString, unionFlag,gioClickHandle } from "@utils";
import { dealTagGoods } from '@/utils/special';
import NavIndex from "./../../lifeIndex/NavIndex";
import BookNavIndex from "./../../book/NavIndex";
import SelectBar from "./SelectBar";
import SearchBar from "./SearchBar";
import Goods from "./../../lifeIndex/GoodsItem";
import FixedButton from "@components/FixedButton";
import { Pagination } from "element-ui";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import Loading from "@components/SimpleLoading";
import SkuPicker from "@components/SkuPicker";
import HealthNav from "@components/nav/HealthNav";
import { Dialog } from "element-ui";
import Cookies from "js-cookie";
import Toast from "@components/simpleToast";
import Empty from "./Empty";
import { healthChannelId, noHeadUnion,channelNames } from "@utils/config";
import { setTitleInfo } from "@utils/title";


// import Toast from '@components/simpleToast';

export default {
  name: "List",
  components: {
    NavIndex,
    BookNavIndex,
    SelectBar,
    SearchBar,
    Goods,
    Pagination,
    SkuPicker,
    Dialog,
    Empty,
    HealthNav,
    FixedButton,
  },
  data() {
    return {
      catList: [],
      longParams: {
        lowerPriceLimit: getQueryString("lp"),
        priceCap: getQueryString("hp"),
        sortType: null,
        sortField: getQueryString("sortField") || "1",
        categoryIdList: [getQueryString("categoryId") || null],
        channelId: getQueryString("channelId") || "2",
        pageNumber: 1,
        pageSize: 20,
        goodsType: getQueryString("goodsType") || "0",
        brandName: getQueryString("bn"),
        wordsName: getQueryString("keyword"),
        categoryName:'',
        containsNoStock: getQueryString('stock') == 'false' ? false : true || true,
      },
      brandList: [],
      goodsList: [],
      total: 0,
      activeGoods: {},
      SkuPickerShow: false,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      dialogVisible: false,
      chooseOfAdd: {},
      isEmpty: false,
      healthChannelId: healthChannelId,
      noHeadUnion: noHeadUnion,
      union: unionFlag(),
      activeBirthdayType:{},
      CookiesOne:Cookies.get('df_lang'),
      noStockGrayStatus: true,
    };
  },
  computed: {
    ...mapGetters("shopCart", ["exts", "healthgoodsFlag", "getCount"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.goodsList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      return goodsList;
    },
  },
  created() {
    this.cartCount({ ...this.addressInfo });
  },
  mounted() {
    this.init();
    if (Number(this.longParams.channelId) === Number(this.healthChannelId)) {
      document.title = this.TLang('东方福利网', 'my') + '-' + this.TLang('健康商城', 'my');
    }
    if (Number(this.longParams.channelId) === 998 || Number(this.longParams.channelId) === 18) {
      document.title = this.TLang('东方福利网', 'my') + '-' + this.TLang('图书', 'my');
    }
    if (Number(this.longParams.channelId) === 3) {
      document.title = this.TLang('东方福利网', 'my') + '-' + this.TLang('生日汇', 'my');
    }
  },
  beforeRouteEnter(to, from, next) {
    // 342
    if (to.query.categoryId === "342") {
      window.df_sdk_common.location.href = "/book";
    }
    next();
  },
  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    init() {
      Loading.show();
      // 综合排序传递值调整
      this.longParams.sortField = this.longParams.sortField === '1' ? '' : this.longParams.sortField;
      // console.log(this.longParams.goodsType,'???')
      // debugger
      //新增后退记录页码
      const pageNumber = getQueryString('pageNumber');
      if(pageNumber){
        this.longParams = {
          ...this.longParams,
          pageNumber: +pageNumber,
        };
      }
      fetchProductListById({ ...this.longParams }).then(body => {
        Loading.hide();
        if (
          this.longParams.channelId === "2" &&
          body.categoryDtos &&
          body.categoryDtos[2] &&
          body.categoryDtos[2].length
        ) {
          this.catList = body.categoryDtos[2];
          this.catList.map((first) => {
            //点击全部 拿上一级「父」id
            if (first.subCategoryList && first.subCategoryList.length > 0) {
              first.subCategoryList.unshift({
                name: TLang('全部', 'my'),
                father: first.name,
                id: first.id,
              });
              first.subCategoryList.map((sub) => {
                sub.father_id = first.id;
                sub.father_name = first.name;
                sub.current_list = first.subCategoryList;
              });
            } else {
              first.subCategoryList = [];
            }
          });
        } else if (this.longParams.channelId === "3" && body.categoryDtos) {
          // 生日汇列表取所有二级 并且单选
          this.catList = [];
          let ETCard = [];
          let caseList = [];
          if (body.categoryDtos[0] && body.categoryDtos[0].length) {
            body.categoryDtos[0].map((caseone) => {
              if (caseone.subCategoryList && caseone.subCategoryList.length) {
                caseList = caseone.subCategoryList.map((cases) => {
                  cases.goodsType = 0;
                  this.catList.push(cases);
                });
              }
            });
          }
          if (body.categoryDtos[1] && body.categoryDtos[1].length) {
            body.categoryDtos[1].map((etone) => {
              if (etone.subCategoryList && etone.subCategoryList.length) {
                let caseList = etone.subCategoryList.map((et) => {
                  et.goodsType = 1;
                  this.catList.push(et);
                });
              }
            });
          }
        } else if (
          this.longParams.channelId === healthChannelId &&
          body.categoryDtos
        ) {
          // 体检商城
          this.catList = (body.categoryDtos && body.categoryDtos[3]) || [];
        } else if (this.longParams.channelId === "998" && body.categoryDtos) {
          // 图书
          this.catList = body.categoryDtos[998];
        } else if (this.longParams.channelId === "18" && body.categoryDtos) {
          // 图书
          this.catList = body.categoryDtos[18];
        } else {
          this.catList = [];
        }
        this.brandList = body.brandDtos || [];
        this.noStockGrayStatus = body.noStockGrayStatus;
        this.goodsList =
          (body.categoryGoodsDtos &&
            body.categoryGoodsDtos.categoryGoodsDtoList) ||
          [];
        this.getGoodsTags();
        if (
          !body.categoryGoodsDtos ||
          !body.categoryGoodsDtos.categoryGoodsDtoList ||
          body.categoryGoodsDtos.categoryGoodsDtoList.length === 0
        ) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        this.total = body.count;
        setTimeout(() => {
          this.scrollTo();
        });

        try {
          const categoryId = getQueryString("categoryId") || getQueryString("goodsType");
          let categoryName = '';

          this.catList.some(item => {
            const id = getQueryString("channelId") == 3 ? item.goodsType : item.id;
            if (id == categoryId) {
              categoryName = item.name  ;
              return true;
            }

            if (item.subCategoryList) {
              return item.subCategoryList.find((sub) => {
                const subId = getQueryString("channelId") == 3 ? sub.goodsType : sub.id;
                if (subId == categoryId) {
                  categoryName = sub.name;
                  return true;
                }
              });
            }
          });

          if (getQueryString("bn") || categoryName) {
            setTitleInfo({
              categoryName: getQueryString("bn") || categoryName,
              activity: '',
            });
          }
        } catch (e) {
          console.error(e);
        }
        // 三级变二级 git版本号
        // be88e24ae2aaf7605ec266b822298e764b2624e8 [be88e24]
        // 数据处理 二级分类添加一级分类信息 二级分类list 第一项增加全部
      });
      this.cartCount({ ...this.addressInfo });
    },
    getName() {
    },
    topre() {
      window.history.go(-1);
    },
    resetLongParams() {
      this.longParams = {
        ...this.longParams,
        lowerPriceLimit: getQueryString("lp"),
        priceCap: getQueryString("hp"),
        sortType: null,
        // sortField: getQueryString("sortField") || "1",
        categoryIdList: [],
        channelId: getQueryString("channelId") || "2",
        pageNumber: 1,
        pageSize: 20,
        goodsType: getQueryString("goodsType") || "0",
        brandName: null,
        wordsName: getQueryString("keyword"),
        categoryName: '全部',
      };
    },
    chooseAll() {
      // console.log('chooseAll=====')
      this.resetLongParams();
      this.longParams = {
        ...this.longParams,
        pageNumber:1,
      };
      this.addPageNumbberQuery({
        categoryId:'',
        pageNumber:'',
      });
      this.init();
      this.$router.push({
        path: "/product/list",
        query: {
          ...this.$route.query,
          pageNumber:null,
          categoryIdList: null,
          categoryId:null,
          bn: null,
          hp: getQueryString("hp"),
          lp: getQueryString("lp"),
          keyword: getQueryString("keyword"),
        },
      });
    },
    onCateChange(item, goodsType = 0) {
      this.longParams = {
        ...this.longParams,
        pageNumber: 1,
        categoryIdList: [item.id],
        goodsType,
        brandName: null,
        // wordsName: null
      };
      this.addPageNumbberQuery({
        pageNumber:'',
      });
      this.init();
    },
    onCateNavChange(id,category,type) {
      const channelId = this.longParams.channelId;
      const params = {
        df_channle:channelNames['channel'+channelId],
        df_pagename:'分类商品列表页',
        df_modulename:'分类导航',
      };
      if(type === 1){
        params.df_elementname = '一级分类';
        params.df_firstCategory = category.name,
        params.df_firstCategoryId = ''+category.id;
      }else if(type === 2){
        params.df_elementname = '二级分类';
        params.df_secondCategory = category.name,
        params.df_secondCategoryId = ''+category.id;
      }else{
        params.df_modulename = '更多分类';
        params.df_elementname = category.name;
      }
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
      window.df_sdk_common.location.href = `/shop/product/list?categoryId=${id}`;
    },
    onBookNavChange(id,category) {
      const channelId = this.longParams.channelId;
      const params = {
        df_channle:channelNames['channel'+channelId],
        df_pagename:'分类商品列表页',
        df_modulename:'分类导航',
        df_elementname:'一级分类',
        df_firstCategory: category.name,
        df_firstCategoryId:''+category.id,
      };
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
      window.df_sdk_common.location.href = `/book/list?categoryId=${id}&channelId=998`;
    },
    // 当前分页
    handleCurrentChange(page) {
      this.longParams = { ...this.longParams, pageNumber: page };
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.addPageNumbberQuery({
        pageNumber:page,
      });
      this.init();
    },
    // 生日汇切换一级分类
    changeBirthdayFirstType(birthday){
      this.activeBirthdayType = birthday;
    },
    sendGio(goods,elementname){
      const channelId = this.longParams.channelId;
      const spuId = goods.mallSpuId || goods.spuId;
      const categoryId = getQueryString('categoryId');
      let categoryName = '';
      if(categoryId && !this.longParams.categoryName){
        this.catList.filter(item => {
          if(item.id == categoryId){
            categoryName = item.name;
          }else if(item.subCategoryList && item.subCategoryList.length > 0){
            item.subCategoryList.filter(sub => {
              if(sub.id == categoryId){
                categoryName = item.name;
              }
            });
          }
        });
      }
      const params = {
        df_channle: channelNames['channel'+channelId],
        df_pagename:'分类商品列表页',
        df_modulename:'商品列表',
        df_elementname:elementname,
        df_firstCategory:this.longParams.categoryName || categoryName || this.activeBirthdayType.name,
        df_goodsname:goods.goodsName,
        df_spu_code:''+ spuId,
      };
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
    },
    // 点击加购跳转详情
    toDetailAndMemory(goods) {
      this.scrollTo();
      this.sendGio(goods,'商品详情');
      // this.saveHashToMemory();
      if (goods.goodsType === 1) {
        let url = `/birthday/goods/detail/${goods.spuId}?city=${
          this.addressInfo.cityId || 145
        }&channelId=2`;
        if (goods.pcUrl){
          url = goods.pcUrl+'&channelId=2';
        }
        window.open(url,this.isFeishuOrDingding ? '_self' : '_blank');
        // window.location.href = `/birthday/goods/detail/${goods.spuId}?city=${
        //   this.addressInfo.cityId || 145
        // }`;
        return;
      }
      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}&channelId=2`,this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    // 点击跳转详情
    toDetail(goods) {
      this.scrollTo();
      window.open(`/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}&channelId=2`,this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}`;
    },
    onClickAdd(goods) {
      this.sendGio(goods,'加购');
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.mallSpuId,
      }).then((body) => {
        if (body && body.length) {
          // 单规格
          if (body.length === 1) {
            const myChoose = {
              ...body[0],
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose, { goods });
            return;
          }
          try {
            let checkList = [];
            body && body.length > 0 && body.forEach(item => {
              item.tags = [];
              if (item.categoryId && item.goodsId) {
                checkList.push({
                  categoryId: item.categoryId,
                  goodsId: item.goodsId,
                });
              }
            });
            checkList && checkList.length > 0 && getActivityTag({
              channel: 2,
              goodsList: checkList,
            }).then((res) => {
              if (res && res.length > 0){
                body && body.length > 0 && body.forEach(item => {
                  item = dealTagGoods(item, res);
                });
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              } else {
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              }
            });
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    onClickSkuAdd(myChoose, g) {
      // console.log(myChoose, g);
      this.chooseOfAdd = { ...myChoose, ...g };
      fetchaddCart({
        categoryId: g.goods.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body === "成功") {
          this.dialogVisible = true;
          this.cartCount({ ...this.addressInfo });
        } else {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    // 已经修改新窗口
    onClickGoBuy() {
      window.open("/shop/shopping/cart",this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = "/shop/shopping/cart";
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.goodsList.forEach((good) => {
        const goodTag = res.find(
          (tag) =>
            tag.categoryId == good.categoryId && tag.goodsId == good.goodsId,
        ) || {};
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        //type  1特价抢购   满减     2爆炸贴       3新品
        let newTags = tags.filter((item) => item.type != 2 );
        let stickerImgList = tags.filter((item) => item.type === 2);
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        this.$set(good, 'purplePriceIcon', newTags.find((item) => item.mktFrontType == 11001));
        this.$set(good, "tags", newTags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        this.$set(good, "bizStock", bizStock);
        // 拼接折扣信息
        this.$set(good, "discount", goodTag.discount);
        this.$set(good, "discountPrice", goodTag.discountPrice);
        this.$set(good, "discountTagShow", goodTag.discountTagShow);
        this.$set(good, "mktTagShow", goodTag.mktTagShow);
        // 爆炸贴数据
        this.$set(good, "stickerImgList", stickerImgList);

        // 福拼拼相关字段
        // Y 为福拼拼
        this.$set(good,"groupItem", goodTag.groupItem);
        // groupItemClassStyle 样式 1、文本模式，2、+货币模式
        this.$set(good,"groupItemClassStyle",goodTag.groupItemClassStyle);
        // 拼团价格
        this.$set(good,"groupItemPrice",goodTag.groupItemPrice);
        // 拼团价格限制 最高可抵扣福豆
        this.$set(good,"groupItemPriceLimit",goodTag.groupItemPriceLimit);
        // 拼团商品是否显示人命币 Y:是 N:否
        this.$set(good,"groupItemShowRmbSymbol",goodTag.groupItemShowRmbSymbol );
        this.$set(good, "dfPriceVo", goodTag.dfPriceVo);
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          },
        );
      }
    },
    //add pageNumber query
    addPageNumbberQuery(queryParams = {}){
      const { pageNumber } = this.longParams;
      if(pageNumber){
        const { pathname } = window.location;
        let { query = {} } = this.$route;
        //Object.keys(queryParams).forEach(v => query[v] = queryParams[v]);
        query = { ...query,...queryParams };
        let params = '?';
        Object.keys(query).forEach((v,i) => {
          params+= `${i ? '&' : ''}${v}=${query[v] || ''}`;
        });
        history.replaceState({},null,`${pathname}${params}`);
      }
    },
    scrollTo(){
      const href = location.href;
      var scroll = sessionStorage.getItem(href);
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scroll){
        window.scrollTo(0,+scroll);
        sessionStorage.removeItem(href);
        return;
      }
      scrollTop > 0 && sessionStorage.setItem(href,scrollTop);
    },
  },
};
</script>

<style lang="less" scoped>
.product-list {
  width: 1300px;
  .SearchBar-wrap {
    margin-top: 24px;
  }
  .bread {
    display:flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    a,
    span {
      color: #666;
      line-height: 48px;
    }
    .arrow {
      width: 16px;
      height: 16px;
      margin: 0 5px;
    }
  }
  .goods-wrap {
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 36px;
        margin-bottom: 10px;
        padding: 30px 0;
        min-height: 282px;
        box-sizing: border-box;
        &:nth-child(5n) {
          margin-right: 0;
        }
        /deep/ .GoodsItem {
          width: 200px;
          padding: 0 15px;
        }
        /deep/ .line-price-box {
          margin: 0;
        }
        /deep/ .discountPriceWrap {
          padding: 0;
        }
        /deep/ .imgBox {
          margin: 0;
          width: 200px;
          height: 200px;
        }
        /deep/ .goods-name {
          padding: 0;
        }
        /deep/ .row-price {
          padding: 0;
        }
      }
    }
  }
  .Pagination {
    /deep/ .el-pagination {
      float: right;
      margin-bottom: 20px;
    }
  }
  /deep/ .product-dialog {
    transform: translateY(-50%);
    text-align: center;
    /deep/ .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        font-size: 24px;
        top: 15px;
      }
    }
    img {
      width: 85px;
      height: 55px;
    }
    /deep/ .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
      }
      /deep/ .btns {
        margin-top: 30px;
        button {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          line-height: 40px;
          &:hover {
            cursor: pointer;
          }
        }
        /deep/ .close-btn {
          border: 1px solid rgba(229, 229, 229, 1);
          color: #999;
          margin-right: 30px;
          width: auto;
        }
        /deep/ .primary {
          background: #3fa6ff;
          background: var(--df-primary-color, #3FA6FF);
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
.close-btn-One{
     width: auto!important;
     padding: 0 15px;
}
</style>
